import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'What exactly do I get?',
  answer: "You get instant, lifetime access to the complete 10-module Dream Decoding System. It's a digital framework you can access immediately on your phone, tablet, or computer. No waiting for shipping."
}, {
  question: 'Is this just another dream dictionary?',
  answer: 'Not at all. Dream dictionaries give you generic meanings that rarely apply to your specific life. This is a step-by-step system that teaches you how to decode your unique dreams based on your personal context and psychology.'
}, {
  question: 'How long does it take to see results?',
  answer: 'You can start decoding your dreams the very first night. The system is designed to be consumed quickly, so you can learn the framework in under an hour and apply it immediately the next time you wake up.'
}, {
  question: 'Is this backed by anything real?',
  answer: 'Yes. The system is built on established psychological principles of dream analysis and subconscious processing, stripped of the academic jargon and turned into a practical, easy-to-use framework for everyday people.'
}, {
  question: "What if it doesn't work for me?",
  answer: "We offer a 7-day money-back guarantee. If you go through the system, apply the framework, and still can't make sense of your dreams, just email us within 7 days of purchase and we'll refund your $19.99 in full. No questions asked."
}];
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-dark-border last:border-0" data-id="element-24">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-25">
        <span className="text-lg sm:text-xl font-medium text-zinc-200 group-hover:text-white transition-colors" data-id="element-26">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-zinc-500 transition-transform duration-300 ml-4 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-27" />
      </button>
      <AnimatePresence data-id="element-28">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-29">
            <p className="pb-6 text-zinc-400 leading-relaxed" data-id="element-30">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  return <section className="py-20 px-2 sm:px-6 lg:px-8 mt-[-20px] mb-[-20px]" data-id="element-31">
      <div className="max-w-3xl mx-auto mt-[-30px] mb-[-30px]" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-33">
          <h2 className="text-3xl sm:text-4xl font-serif mb-4" data-id="element-34">
            Frequently Asked Questions
          </h2>
          <div className="w-12 h-1 bg-gold mx-auto rounded-full" data-id="element-35" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-dark-card border border-dark-border rounded-2xl px-6 sm:px-8 mt-[-32px] mb-[-32px]" data-id="element-36">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-37" />)}
        </motion.div>
      </div>
    </section>;
}